import { Box, Typography, styled } from '@mui/material';
import { OMIT_LENDER_REFERENCE_ID } from '../constants';
import {
  useGetOfferDescription,
  useGetSettlementData,
} from '../services/flowManager';

const Container = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  margin: '30px auto',
  '& p': {
    padding: 10,
    color: theme.palette.primary.main,
    backgroundColor: theme.palette.secondary.light,
  },
}));

const AdditionalDataTypography = styled(Typography)({
  fontWeight: 500,
  fontSize: 18,
});

const OrderData = () => {
  const settlementData = useGetSettlementData();
  const offerDescription = useGetOfferDescription();
  return (
    <Container>
      <Typography
        component="p"
        variant="h2"
        align="center"
        data-testid="transaction-id"
      >
        Order ID: {settlementData.orderId}
      </Typography>
      {settlementData.shouldSettle &&
        settlementData.lenderReferenceId &&
        settlementData.lenderReferenceId !== OMIT_LENDER_REFERENCE_ID && (
          <AdditionalDataTypography align="center" data-testid="lender-ref">
            Lender Reference ID:
            <br />
            {settlementData.lenderReferenceId}
          </AdditionalDataTypography>
        )}
      {settlementData.approvalCode && (
        <AdditionalDataTypography align="center" data-testid="approval-code">
          Approval Code:
          <br />
          {settlementData.approvalCode}
        </AdditionalDataTypography>
      )}
      {offerDescription && (
        <AdditionalDataTypography
          align="center"
          data-testid="offer-description"
        >
          Description:
          <br />
          {offerDescription}
        </AdditionalDataTypography>
      )}
    </Container>
  );
};

export default OrderData;
